import * as React from "react";

export const FlagIcon: React.SFC = ({}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path d="M0 0h24v24H0z" fill="none" />
    <path d="M14.4 6L14 4H5v17h2v-7h5.6l.4 2h7V6z" />
  </svg>
);



// WEBPACK FOOTER //
// ./src/documentList/FlagIcon.tsx